export const arePrimaryAttrsFilled = (
  attrs: Array<{ id: any; isPrimary?: boolean }> | null | undefined,
  cards: Array<{ attr?: any; attributeType?: any }> | null | undefined,
): boolean => {
  if (!attrs || !cards || !attrs.filter || !cards.some) return false;

  const primaryAttrs = attrs.filter((attr) => attr && attr.isPrimary);

  if (primaryAttrs.length === 0) return true;

  return primaryAttrs.every((attr) =>
    cards.some(
      (card) =>
        card && (card.attr === attr.id || card.attributeType === attr.id),
    ),
  );
};
